import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { namespaces, resources, supportedLngs } from './resources';

export { namespaces, supportedLngs };

i18next.use(initReactI18next).init({
  resources,
  ns: namespaces,
  defaultNS: 'common',
  lng: import.meta.env.MODE === 'test' ? 'cimode' : 'sv',
  appendNamespaceToCIMode: true,
  fallbackLng: 'sv',
  supportedLngs: [...supportedLngs, 'cimode'],
  load: 'languageOnly',
  nsSeparator: ':',
  keySeparator: false,
  interpolation: { escapeValue: false },
  initAsync: false,
  saveMissing: import.meta.env.DEV,
  missingKeyHandler: (lngs, ns, key) => {
    if (import.meta.env.DEV) console.warn(`[i18n] missing key "${ns}:${key}" for ${lngs.join(', ')}`);
  },
});

export default i18next;
